import { render, staticRenderFns } from "./BaseLayer.vue?vue&type=template&id=0cb3a1d6&lang=pug"
import script from "./BaseLayer.vue?vue&type=script&lang=ts"
export * from "./BaseLayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports